/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

